<p-toast key="preoffer-review" position="top-right"></p-toast>
<p-confirmDialog
  key="preoffer-review"
  [style]="{ width: '460px' }"
  acceptButtonStyleClass="p-button-sm"
  rejectButtonStyleClass="p-button-sm p-button-text"
></p-confirmDialog>

<p-card styleClass="preoffer-review-card">
  <div class="review-header">
    <div class="header-left">
      <a
        pButton
        class="p-button-text p-button-rounded p-button-sm back"
        icon="fa-solid fa-arrow-left"
        routerLink="/preofertas/legal"
        aria-label="Volver a la bandeja"
      ></a>
      <span class="page-icon is-primary"><i class="fa-solid fa-file-signature" aria-hidden="true"></i></span>
      <div class="header-text">
        <h1>{{ statusUi?.title || 'Preoferta' }}</h1>
        <p class="header-subtitle" *ngIf="detail">
          <a [routerLink]="['/customer', detail.client]" data-test="review-client">{{ detail.clientSummary?.name || 'Cliente' }}</a>
          <span class="rfc" *ngIf="detail.clientSummary?.rfc">{{ detail.clientSummary?.rfc }}</span>
          <ng-container *ngIf="detail.lease">
            <span class="sep" aria-hidden="true">·</span>
            <span
              >Arrendamiento
              <a [routerLink]="['/lease', detail.lease]" [queryParams]="{ tab: 'algoritmo' }" data-test="review-lease">{{
                detail.leaseFolio || 'sin folio'
              }}</a></span
            >
          </ng-container>
        </p>
      </div>
    </div>
    <div class="header-right" *ngIf="statusUi">
      <p-tag [severity]="statusUi.severity" [icon]="statusUi.icon" [value]="statusUi.label" data-test="review-status"></p-tag>
    </div>
  </div>

  <div class="review-body">
    <div class="empty-state" *ngIf="loading && !detail" data-test="review-loading">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      <span>Cargando la preoferta…</span>
    </div>

    <div class="empty-state is-error" *ngIf="loadError" role="alert" data-test="review-error">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <h3>No pudimos cargar la preoferta</h3>
      <span>{{ loadError }}</span>
      <button
        pButton
        type="button"
        class="p-button-outlined p-button-sm"
        icon="fa-solid fa-rotate-right"
        label="Reintentar"
        (click)="load()"
      ></button>
    </div>

    <div class="review-grid" *ngIf="detail && !loadError">
      <div class="review-main">
        <section class="info-card" aria-labelledby="signals-title">
          <div class="card-header">
            <span class="card-icon is-orange"><i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i></span>
            <div class="header-title-group">
              <span class="card-eyebrow">Por qué la revisa Legal</span>
              <h3 id="signals-title">Señales para Legal</h3>
            </div>
            <div class="header-tags">
              <p-tag
                severity="warning"
                [value]="detail.legalSignals.length + (detail.legalSignals.length === 1 ? ' señal' : ' señales')"
              ></p-tag>
            </div>
          </div>
          <div class="card-content">
            <p class="banner is-warn" *ngIf="snapshotDrift as drift" role="status" data-test="review-drift">
              <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
              <span
                >La foto cambió desde que se pidió la autorización (revisión {{ drift.from }} → {{ drift.to }}). Revisa la foto antes de
                decidir.</span
              >
            </p>

            <ul class="signals" data-test="review-signals">
              <li class="signal-row" *ngFor="let signal of detail.legalSignals">
                <span class="signal-icon"><i class="fa-solid" [ngClass]="signalIcon(signal.kind)" aria-hidden="true"></i></span>
                <div class="signal-text">
                  <span class="signal-label">{{ signal.label }}</span>
                  <span class="signal-meta"
                    >{{ signal.count }} {{ signal.count === 1 ? 'hallazgo' : 'hallazgos' }} en la foto de Syntage</span
                  >
                </div>
                <a
                  pButton
                  class="p-button-text p-button-sm signal-link"
                  label="Ver en la foto"
                  icon="fa-solid fa-arrow-up-right-from-square"
                  iconPos="right"
                  [routerLink]="['/customer', detail.client]"
                  [queryParams]="{ tab: 'ciec', subtab: subtabFor(signal.kind) }"
                  target="_blank"
                  rel="noopener"
                  [attr.aria-label]="'Ver ' + signal.label + ' en la foto (se abre en otra pestaña)'"
                ></a>
              </li>
              <li *ngIf="!detail.legalSignals.length" class="signal-empty">Sin señales registradas.</li>
            </ul>
          </div>
        </section>

        <section class="info-card" aria-labelledby="offer-title">
          <div class="card-header">
            <span class="card-icon is-green"><i class="fa-solid fa-hand-holding-dollar" aria-hidden="true"></i></span>
            <div class="header-title-group">
              <span class="card-eyebrow">Congelado al decidir</span>
              <h3 id="offer-title">Lo que se ofrece</h3>
            </div>
          </div>
          <div class="card-content">
            <div class="compact-grid" data-test="review-facts">
              <div class="compact-item is-highlight">
                <span class="label">Monto preaprobado (IVA incluido)</span>
                <span class="value success money">
                  {{ detail.expectedAmount !== null ? (detail.expectedAmount | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—' }}
                  <p-tag *ngIf="detail.capped" severity="warning" value="Salió por el tope" data-test="review-capped"></p-tag>
                </span>
              </div>
              <div class="compact-item full-width is-capped" *ngIf="detail.capped && detail.capacity" data-test="review-capacity">
                <span class="label">Capacidad estimada (solo para el equipo)</span>
                <span class="value money">{{ detail.capacity | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
                <span class="hint">Al emitirse se avisa a su comercial: se le podría ofrecer más.</span>
              </div>
              <div class="compact-item">
                <span class="label">Plazo</span>
                <span class="value money">{{ preapproval?.termMonths ? preapproval?.termMonths + ' meses' : '—' }}</span>
              </div>
              <div class="compact-item">
                <span class="label">Pago mensual estimado</span>
                <span class="value money">{{
                  preapproval?.monthlyPayment ? (preapproval?.monthlyPayment | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—'
                }}</span>
              </div>
              <div class="compact-item">
                <span class="label" title="La misma calculadora del expediente del cliente (D-74)">Calificación del cliente</span>
                <span class="value money score">
                  {{ scoreText }} <small>de 110</small>
                  <p-tag *ngIf="bandUi" [severity]="bandUi.severity" [value]="bandUi.label"></p-tag>
                </span>
              </div>
              <div class="compact-item">
                <span class="label">Oferta máxima del análisis</span>
                <span class="value money">{{
                  detail.inputs?.['maxOffer'] ? (detail.inputs?.['maxOffer'] | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : 'Sin rango'
                }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section class="info-card decision" aria-labelledby="decision-title">
        <div class="card-header">
          <span class="card-icon is-primary"><i class="fa-solid fa-gavel" aria-hidden="true"></i></span>
          <div class="header-title-group">
            <span class="card-eyebrow">Legal</span>
            <h3 id="decision-title">Decisión</h3>
          </div>
        </div>
        <div class="card-content">
          <div class="compact-grid is-single">
            <div class="compact-item">
              <span class="label">Disparador</span>
              <span class="value">{{ (detail.trigger && triggers[detail.trigger]) || '—' }}</span>
            </div>
            <div class="compact-item" *ngIf="detail.legalSince">
              <span class="label">En espera desde</span>
              <span class="value">{{ detail.legalSince | mxDate }}</span>
            </div>
          </div>

          <p class="banner" *ngIf="isPending && !canReview" data-test="review-readonly">
            <i class="fa-solid fa-lock" aria-hidden="true"></i>
            <span>Solo Legal autoriza o regresa. La ves en solo lectura.</span>
          </p>

          <div class="outcome is-good" *ngIf="detail.status === 'issued'" data-test="review-authorized">
            <span class="outcome-icon"><i class="fa-solid fa-circle-check" aria-hidden="true"></i></span>
            <div class="outcome-text">
              <strong>Autorizada el {{ detail.review?.at | mxDate }}</strong>
              <span>La carta salió por {{ detail.offer?.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}.</span>
            </div>
          </div>

          <div class="outcome is-bad" *ngIf="detail.status === 'returned'" data-test="review-returned">
            <span class="outcome-icon"><i class="fa-solid fa-rotate-left" aria-hidden="true"></i></span>
            <div class="outcome-text">
              <strong>Regresada a revisión el {{ detail.review?.at | mxDate }}</strong>
              <blockquote>{{ detail.review?.reason }}</blockquote>
              <span class="outcome-note">El cliente la ve «En revisión».</span>
            </div>
          </div>

          <ng-container *ngIf="editable">
            <div class="actions" *ngIf="!returning">
              <button
                pButton
                type="button"
                icon="fa-solid fa-paper-plane"
                [label]="deciding === 'authorized' ? 'Autorizando…' : 'Autorizar y enviar'"
                [loading]="deciding === 'authorized'"
                [disabled]="saving"
                (click)="authorize()"
                data-test="review-authorize"
              ></button>
              <button
                pButton
                type="button"
                icon="fa-solid fa-rotate-left"
                label="Regresar a revisión"
                class="p-button-outlined p-button-danger"
                [disabled]="saving"
                (click)="startReturn()"
                data-test="review-return"
              ></button>
            </div>

            <div class="return-form" *ngIf="returning">
              <label for="return-reason">Motivo (lo verá el equipo, no el cliente)</label>
              <textarea
                id="return-reason"
                pInputTextarea
                rows="4"
                [(ngModel)]="reason"
                [attr.aria-invalid]="reason.length > 0 && !reasonValid"
                data-test="review-reason"
              ></textarea>
              <small class="hint" [class.is-bad]="reason.length > 0 && !reasonValid"
                >Al menos {{ minReason }} caracteres. El cliente solo ve «En revisión».</small
              >
              <div class="form-actions">
                <button
                  pButton
                  type="button"
                  label="Cancelar"
                  class="p-button-text p-button-sm"
                  [disabled]="saving"
                  (click)="returning = false"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="fa-solid fa-rotate-left"
                  label="Regresar a revisión"
                  class="p-button-danger p-button-sm"
                  [loading]="deciding === 'returned'"
                  [disabled]="saving || !reasonValid"
                  (click)="submitReturn()"
                  data-test="review-return-submit"
                ></button>
              </div>
            </div>
          </ng-container>
        </div>
      </section>
    </div>
  </div>
</p-card>
